import { Button, Drawer, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import MarkdownRenderer from '@/components/MarkdownRenderer';
import {
  getSiteMessageDetail,
  markSiteMessageRead,
  type SiteMessageItem,
} from '@/services/notification/siteMessage';
import { notifySiteMessageUnreadChanged } from '@/utils/siteMessageUnread';
import useStyles from './SiteMessageDetailDrawer.style';

export interface SiteMessageDetailDrawerProps {
  open: boolean;
  siteMessageId?: string;
  onClose: () => void;
  onRead?: () => void;
}

const SiteMessageDetailDrawer: React.FC<SiteMessageDetailDrawerProps> = ({
  open,
  siteMessageId,
  onClose,
  onRead,
}) => {
  const { styles } = useStyles();
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState<SiteMessageItem>();

  useEffect(() => {
    if (!open || !siteMessageId) {
      setDetail(undefined);
      return;
    }

    void (async () => {
      setLoading(true);
      try {
        const res = await getSiteMessageDetail({ siteMessageId });
        setDetail(res);
        if (res?.unread) {
          await markSiteMessageRead({ siteMessageId });
          notifySiteMessageUnreadChanged();
          onRead?.();
        }
      } catch (error) {
        console.error('获取站内信详情失败:', error);
        setDetail(undefined);
      } finally {
        setLoading(false);
      }
    })();
  }, [open, onRead, siteMessageId]);

  return (
    <Drawer
      title="通知详情"
      open={open}
      onClose={onClose}
      size={640}
      closable={{ placement: 'end' }}
      destroyOnHidden
      footer={
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose}>关闭</Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        {detail ? (
          <div>
            <h3
              style={{
                margin: '0 0 12px',
                fontSize: 18,
                fontWeight: 600,
                lineHeight: 1.5,
              }}
            >
              {detail.title}
            </h3>
            <div style={{ marginBottom: 16, color: 'rgba(0,0,0,0.45)' }}>
              发送时间：{detail.publishedAt || '-'}
            </div>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>通知内容</div>
            <div className={styles.contentBox}>
              {detail.content ? (
                <MarkdownRenderer content={detail.content} />
              ) : (
                '-'
              )}
            </div>
          </div>
        ) : null}
      </Spin>
    </Drawer>
  );
};

export default SiteMessageDetailDrawer;
